import React, { useState } from 'react';
import { Card, CardContent, CardMedia, makeStyles } from '@material-ui/core';
import { CapaQuotationPartnerPortfolio } from '@generated/graphql';
import { getFileUrl } from '@utils/urls';
import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import PortfolioDetailView from './DetailView/PortfolioDetailView';

interface PortfolioCardProps {
  portfolio: CapaQuotationPartnerPortfolio;
}

const PortfolioCard: React.FunctionComponent<PortfolioCardProps> = ({
  portfolio
}) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const { portfolioCardContainer } = useStyles();
  const thumbnail = getFileUrl(portfolio.files?.[0].fileId ?? '');

  return (
    <>
      <PortfolioDetailView
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        portfolio={portfolio}
      />
      <Card
        className={portfolioCardContainer}
        onClick={() => {
          setOpenDialog(true);
        }}
      >
        <CardMedia
          className="portfolio-thumbnail"
          image={thumbnail}
        ></CardMedia>
        <CardContent className="portfolio-content">
          <CustomizedTypography
            variant="body1"
            fontWeight="500"
            color="textPrimary"
            className="portfolio-content-title"
          >
            {portfolio.projectName}
          </CustomizedTypography>

          <CustomizedTypography variant="body2" color="textPrimary">
            {portfolio.client}
          </CustomizedTypography>

          <CustomizedTypography
            variant="body2"
            color="textSecondary"
            className="portfolio-content-description"
          >
            {portfolio.description}
          </CustomizedTypography>
        </CardContent>
      </Card>
    </>
  );
};

export default PortfolioCard;

const useStyles = makeStyles((theme) => ({
  portfolioCardContainer: {
    width: '100%',
    height: '294px',
    boxShadow: 'none',
    '&:hover': {
      cursor: 'pointer',
      '& .portfolio-content-title': {
        textDecoration: 'underline'
      }
    },
    '& .portfolio-thumbnail': {
      width: '100%',
      height: 190,
      borderRadius: '12px',
      position: 'relative'
    },
    '& .portfolio-content': {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      padding: '12px 0px 0px 0px'
    },
    '& .portfolio-content-description': {
      wordBreak: 'break-all',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      whiteSpace: 'normal'
    },
    [theme.breakpoints.down('xs')]: {
      flexShrink: '0',
      maxWidth: '256px'
    }
  },
  editableBadge: {
    width: '44px',
    height: '26px',
    borderRadius: '4px',
    backgroundColor: colorSet.gray200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: '12px',
    right: '12px',
    fontSize: 14
  }
}));
